export default __webpack_public_path__ + "static/media/target.29664e2e.svg";